<div class="messenger-mobile-nav__content flex">
  <button class="messenger-mobile-nav__button" (click)="navButtonClick()">
    <img class="messenger-mobile-nav__button-image" src="../../../assets/images/icons/arrow-left.svg" />
  </button>
  <div class="messenger-mobile-nav__label flex justify-center">{{ conversationParticipantName }}</div>
</div>
